import { render, staticRenderFns } from "./CbsCtrlRelation.vue?vue&type=template&id=3e6ad84a&scoped=true"
import script from "./CbsCtrlRelation.vue?vue&type=script&lang=js"
export * from "./CbsCtrlRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ad84a",
  null
  
)

export default component.exports